import { useTranslation } from "react-i18next";
import { Button, PlusIcon } from "melco-ui";
import { useFormikContext } from "formik";

type AddFormButtonProps = {
  disabled?: boolean;
};

export const AddFormButton: React.FC<AddFormButtonProps> = ({ disabled }) => {
  const { t } = useTranslation();
  const { isSubmitting, isValid, submitForm } = useFormikContext();

  return (
    <Button
      key="add"
      type="primary"
      icon={<PlusIcon />}
      disabled={isSubmitting || !isValid || disabled}
      loading={isSubmitting}
      onClick={submitForm}
    >
      {t("global.button.add")}
    </Button>
  );
};
